import axios from 'axios';
import React from 'react';
import {Link} from 'react-router-dom';
import {toast} from 'react-toastify';

class Login extends React.Component{

    state = {
        email:'',
        password:'',
        emailErr:'',
        passwordErr:'',
    }

    formSubmit = async(e) => {
        e.preventDefault();
        let {
            email,
            password
        } = this.state;

        if(password.length < 6){
            this.setState({passwordErr:'Must be atleast 6 characters'})
        }
        
        if(!email.includes('@')){
            this.setState({emailErr:'Enter valid email'})
        }

        else{
            try{
                let response = await axios.post('https://scrape.businesstoys.in/student-login', {
                    email,
                    password
                });

                console.log(response.data);

                if(response.data.status === 'Unaproved'){
                    toast.error('Unapproved, Contact your mentor', {
                        position: "top-center",
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        }); 
                }

                if(response.data.status === 'Authenticated'){
                    localStorage.setItem('ivnj', response.data.token);
                    localStorage.setItem('isLoggedIn', true);
                    this.props.updateLogin(true);
                    this.setState(this.state);
                    toast.success('Logged In, Start Applying');
                    window.location.href = '/'
                }

            }catch(err){
                console.log(err);
                this.setState({emailErr:'Check Email', passwordErr:'Check Password'})
                toast.error('Check email & password', {
                    position: "top-center",
                    autoClose: false,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    });
            }
        }

    }

    closeClick = () => {
        this.props.updateModal(false)
    }
    
    render(){
        return(
            <section className="login"  style={{display:this.props.showModal ? 'flex' : 'none' }}  >
                <form className="login__container" onSubmit={this.formSubmit} >
                    <div className="login__container__close" onClick={this.closeClick} >
                        <i className="fas fa-times"></i>
                    </div>
                    <h2>Login</h2>
                    <div className="login__container__ip" >
                        <label>Email</label>
                        <input type="email"
                            value={this.state.email}
                            onChange={(e)=>this.setState({email:e.target.value})}
                            required
                            name="email" placeholder="edward@example.com" />
                        <span>
                            {this.state.emailErr && <i className="fas fa-info-circle"></i>}
                            {this.state.emailErr}
                        </span>
                    </div>
                    <div className="login__container__ip" >
                        <label>Password</label>
                        <input type="password" 
                            value={this.state.password}
                            onChange={(e)=>this.setState({password:e.target.value})}
                            name="password" placeholder="Must be atleast 6 characters"
                            required
                            />
                        <span>
                            { this.state.passwordErr && <i className="fas fa-info-circle"></i>}
                            {this.state.passwordErr}
                        </span>
                    </div>
                    <button>Login</button>
                    <p>New to Business Toys? &nbsp;
                        <Link to="/register" onClick={this.closeClick} >
                            Register
                        </Link>
                    </p>
                </form>
            </section>        
        )
    }
};

export default Login;